import React from 'react';
import './result-page.scss';
import {useParams} from 'react-router-dom';

interface TitlePage {
  type: 'success' | 'warning' | 'error',
  label: string
}

function ResultPage({ title, messages, components, optionalClass }: { title: TitlePage; messages?: string[], components?: Function[], optionalClass?: string }) {

  const {errorMessage} = useParams();

  const setClass = () => {
    let className: string = 'page-container ';
    className += optionalClass ? optionalClass : '';
    return className;
  };

  return (
    <div className={setClass()}>
      <h3 className={`page-title-${title.type}`}>{title.label}</h3>
      {messages && messages.map((message, index) => (
        <p key={`m_${index}`}>{message}</p>
      ))}
      { errorMessage ? <p>{errorMessage}</p> : ''}
      {components && components.map((component, index) =>
        <div key={`c_${index}`}>{component()}</div>
      )}
    </div>
  );
}

export default ResultPage;
